import { useEffect, useState } from "react";
import { isPhoneMuted } from "@/utils/nativePush";

/* État silencieux/vibreur du téléphone (app native uniquement) : vérifié au
   montage, à chaque retour au premier plan et toutes les 30 s. null = inconnu/web. */
export function usePhoneMuted(intervalMs = 30000) {
  const [muted, setMuted] = useState(null);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      const v = await isPhoneMuted();
      if (alive) setMuted(v);
    };
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    check();
    const timer = setInterval(check, intervalMs);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      alive = false;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [intervalMs]);

  return muted;
}
